import { config } from "./config.js";
import { features } from "./features.js";
import Model from "./Model.js";
import EngineController from "../../../shared/controller/EngineController.js";

const model = new Model(
	config.panel,
	config.pluses,
	config.engines,
	config.navigation,
);

document.addEventListener("alpine:init", () => {
	Alpine.store("controller", new EngineController(model, config, features));
});
